import dayjs from "dayjs";
import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
